import { html, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './cta-event.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import { SlottedController } from '../../controllers/slotted-controller.ts';

export default class CtaEvent extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * CTA Event header
       */
      heading: { type: String },
      /**
       * CTA Event host 1
       */
      hostName1: { type: String },
      /**
       * CTA Event host 2
       */
      hostName2: { type: String },
      /**
       * CTA Event date
       */
      eventDate: { type: String },
      /**
       * CTA Event time
       */
      eventTime: { type: String },
      /**
       * Is one column
       */
      isOneColumn: { type: String },
    };
  }

  private = new SlottedController(this);

  constructor() {
    super();
  }

  render() {
    return html`
      <div class="${classMap({
        'cta-event': true,
        [`cta-event--${this.isOneColumn}`]: !!this.isOneColumn,
      })}">
        <div class="info">
          <hf-share url="${window.location.href}" text="${this.heading}" styleclass="purple">
          </hf-share>
          <hf-heading level="1" levelStyle="heading2" class="header">
            ${this.heading}
          </hf-heading>
          <div class="picture-host-date">
            <slot name="host-picture" class="host-picture"></slot>
            <div class="event-info">
              <div class="host-names">
                <strong class="host-names-title">Event Host</strong>
                <span>${this.hostName1}</span>
                <span>${this.hostName2}</span>
              </div>
              <div class="event-date">
                <strong class="event-date-title">Date & Time</strong>
                <span>${this.eventDate}</span>
                <span>${this.eventTime}</span>
              </div>
            </div>
          </div>
          <hr />
          <slot name="event-body" class="event-body"></slot>
        </div>
        <div class="form">
          <slot name="event-form"></slot>
        </div>
      </div>
    `;
  }
}

customElements.define('hf-cta-event', CtaEvent);
